import * as React from "react";
import styled from "styled-components";

import {
  AVAILABLE_COUNTRIES,
  AVAILABLE_LANGS,
  ORIGIN,
  WHATS_INCLUDED_TYPE,
} from "@typings/globals";

import { SkeletonGenerator, Margins } from "@ui/Atoms";
import { WhatsIncludedContent } from "@ui/Molecules/WhatsIncludedContent";

import { usePrismic } from "@hooks/usePrismic";

interface Props {
  origin: ORIGIN;
  lang: AVAILABLE_LANGS;
  contentType: WHATS_INCLUDED_TYPE;
  country: AVAILABLE_COUNTRIES;
}

const ModalContentWhatIsIncluded = (props: Props): React.ReactElement => {
  const { getPrismicEntry, isApiReady } = usePrismic();
  const [content, setContent] = React.useState<null | { [k: string]: any }>(
    null,
  );

  React.useEffect(() => {
    if (!isApiReady) {
      return;
    }

    (async () => {
      const response = await getPrismicEntry({
        contentType: "whats_included_modal",
        origin: props.origin,
        lang: props.lang,
        country: props.country,
      });

      if (response?.length) {
        setContent(response[0]?.data);
      }
    })();
  }, [props.lang, isApiReady]);

  return (
    <Margins xs={["base", "base_x2", null, null]}>
      <React.Fragment>
        <StyledIncluded>
          {content ? (
            <WhatsIncludedContent
              data={content[props.contentType]}
              hasSeparator
            />
          ) : (
            <SkeletonGenerator count={10} randomWidth={80} />
          )}
        </StyledIncluded>
      </React.Fragment>
    </Margins>
  );
};

ModalContentWhatIsIncluded.displayName = "ModalContentWhatIsIncluded";

export { ModalContentWhatIsIncluded };

const StyledIncluded = styled.div`
  h2 {
    margin-bottom: ${props => props.theme.margins.base_x4};
    font-size: ${props => props.theme.fonts.sizes.body2};
    font-weight: ${props => props.theme.fonts.weights.bold};
  }

  p,
  ul,
  div {
    color: ${props => props.theme.palette.grey600};
    font-size: ${props => props.theme.fonts.sizes.caption};
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      margin-bottom: ${props => props.theme.margins.base};
      position: relative;
      padding-left: ${props => props.theme.margins.base_x2};

      &::before {
        color: ${props => props.theme.palette.green500};
        content: "✓";
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
`;
